import { createSelector } from 'reselect';

import { IApplicationState } from '../../types/redux';
import { prepareRateTitleByDate } from '../../utils/prepareRateTitleByDate';

const getMortgageCalculatorBanner = (state: IApplicationState) => state.fsk?.mortgageCalculatorBanner;
const getBaseCalculatorConfig = (state: IApplicationState) => state.fsk?.baseCalculatorConfig;

export const getFskCalculator = createSelector(
  [getMortgageCalculatorBanner, getBaseCalculatorConfig],
  (mortgageCalculatorBanner, baseCalculatorConfig) => {
    if (!mortgageCalculatorBanner || !baseCalculatorConfig) {
      return null;
    }

    return {
      ...baseCalculatorConfig,
      rate: {
        title: prepareRateTitleByDate(baseCalculatorConfig.rate.title),
        tooltip: mortgageCalculatorBanner.hint,
        defaultValue: Number(mortgageCalculatorBanner.ratePercent),
        label: `${mortgageCalculatorBanner.ratePercent}%`,
      },
    };
  },
);
